<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title>المستخدمين</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>

        <v-dialog
          v-model="add_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-btn slot="activator" color="primary" dark class="mb-2">جديد</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">اضافة مستخدم</span>
              <v-btn
                color="primary"
                style="float:left"
                dark
                @click="dialog_add_per = true"
                >الصلاحيات</v-btn
              >
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        disabled
                        v-model="mycode"
                        label="كود المستخدم"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.code')"
                        data-vv-name="code"
                        data-vv-scope="form1"
                      >
                      </v-text-field>
                    </v-flex>
                    <!-- 
                  <v-flex xs12 sm6 md4>
                    <v-text-field v-model="newItem.name" label="أسم المستخدم" v-validate="'required'"
                        :error-messages="errors.collect('form1.name')" data-vv-name="name" data-vv-scope="form1" >
                    </v-text-field>
                  </v-flex> -->

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.username"
                        label="اسم الدخول "
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.username')"
                        data-vv-name="username"
                        data-vv-scope="form1"
                      >
                      </v-text-field>
                    </v-flex>

                    <!-- <v-flex xs12 sm6 md4>
                    <v-text-field v-model="newItem.password" label="الرقم السري "  v-validate="'required'"
                        :error-messages="errors.collect('form1.password')" data-vv-name="password" data-vv-scope="form1" >
                    </v-text-field>
                  </v-flex> -->

                    <v-flex xs12 sm6 md4>
                      <v-text-field v-model="newItem.email" label="الايميل ">
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_employer"
                        :hint="
                          `${select_employer.job_name}, ${select_employer.name}`
                        "
                        :items="employers"
                        item-text="name"
                        item-value="id"
                        label="أختر الموظف"
                        persistent-hint
                        return-object
                        single-line
                        @change="change_username()"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_branch"
                        :items="branches"
                        item-text="name"
                        item-value="id"
                        label="أختر الفرع"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.job')"
                        data-vv-name="job"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_mohafza"
                        :items="mohafzas"
                        item-text="name"
                        item-value="id"
                        label="أختر المحافظة"
                        persistent-hint
                        return-object
                        single-line
                        @change="getCities(select_mohafza.id)"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.mohafza')"
                        data-vv-name="mohafza"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_city"
                        :items="cities"
                        item-text="name"
                        item-value="id"
                        label="أختر المدينة"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.job')"
                        data-vv-name="job"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save('form1')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="edit_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-card>
            <v-card-title>
              <span class="headline">تعديل مستخدم</span>
              <v-btn
                color="primary"
                style="float:left"
                dark
                @click="dialog_edit_per = true"
                >الصلاحيات</v-btn
              >
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      disabled
                      v-model="editedItem.code"
                      label="كود المستخدم"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.code')"
                      data-vv-name="code"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>

                  <!-- <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.name" label="أسم المستخدم" v-validate="'required'"
                        :error-messages="errors.collect('form2.name')" data-vv-name="name" data-vv-scope="form2"></v-text-field>
                  </v-flex> -->

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.username"
                      label="اسم الدخول "
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.username')"
                      data-vv-name="username"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.email"
                      label=" الايميل"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_employer_edit"
                      :hint="
                        `${select_employer_edit.job_name}, ${
                          select_employer_edit.name
                        }`
                      "
                      :items="employers"
                      item-text="name"
                      item-value="id"
                      label="أختر الموظف"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form1.manger')"
                      data-vv-name="manger"
                      data-vv-scope="form1"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_branch_edit"
                      :items="branches"
                      item-text="name"
                      item-value="id"
                      label="أختر الفرع"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form1.job')"
                      data-vv-name="job"
                      data-vv-scope="form1"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_mohafza_edit"
                      :items="mohafzas"
                      item-text="name"
                      item-value="id"
                      label="أختر المحافظة"
                      persistent-hint
                      return-object
                      single-line
                      @change="getCities(select_mohafza_edit.id)"
                      v-validate="'required'"
                      :error-messages="errors.collect('form1.job')"
                      data-vv-name="job"
                      data-vv-scope="form1"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_city_edit"
                      :items="cities"
                      item-text="name"
                      item-value="id"
                      label="أختر المدينة"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form1.job')"
                      data-vv-name="job"
                      data-vv-scope="form1"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click="update('form2')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialog_add_per"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          scrollable
          left
        >
          <v-card tile>
            <v-toolbar card dark color="orange">
              <v-btn icon dark @click="dialog_add_per = false">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>اضافة الصلاحيات </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark flat @click="dialog_add_per = false">حفظ</v-btn>
              </v-toolbar-items>
              <v-menu bottom right offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn dark icon v-on="on">
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <!-- <v-list-tile v-for="(item, i) in items" :key="i" @click="س">
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  </v-list-tile> -->
                </v-list>
              </v-menu>
            </v-toolbar>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.branches"
                    color="orange darken-3"
                    label="الفروع"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.regions"
                    color="orange darken-3"
                    label="المناطق"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.users"
                    color="orange darken-3"
                    label="المستخدمين"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.clients"
                    color="orange darken-3"
                    label="العملاء"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.importers"
                    color="orange darken-3"
                    label="الموردين"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.stores"
                    color="orange darken-3"
                    label="المخازن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.groups"
                    color="orange darken-3"
                    label="المجموعات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.items"
                    color="orange darken-3"
                    label="الاصناف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.khazinas"
                    color="orange darken-3"
                    label="الخزينة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.banks"
                    color="orange darken-3"
                    label="البنوك"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.masrofat_types"
                    color="orange darken-3"
                    label="انواع المصروفات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.cars"
                    color="orange darken-3"
                    label="السيارات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.store_employer_link"
                    color="orange darken-3"
                    label="ربط موظف بمخزن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.store_item_start"
                    color="orange darken-3"
                    label="بداية الاصناف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.store_transfer"
                    color="orange darken-3"
                    label="تحويلات المخازن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.transfer_fatworas"
                    color="orange darken-3"
                    label="فواتير تحويلات المخازن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.taslim_fatwora"
                    color="orange darken-3"
                    label="قبول المندوب اذن الصرف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.reback_fatworas"
                    color="orange darken-3"
                    label="فواتير المرتجعات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.sarf_card"
                    color="orange darken-3"
                    label="كارت صنف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.orders"
                    color="orange darken-3"
                    label="اوامر التوريد"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.tanfiz_fatworas"
                    color="orange darken-3"
                    label="قيد التنفيذ"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.sarf_from_stores"
                    color="orange darken-3"
                    label="الصرف من المخزن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.solmt_fatworas"
                    color="orange darken-3"
                    label="قبول العميل الفاتورة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.sell_reback"
                    color="orange darken-3"
                    label="مرتجعات العملاء"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.final_fatworas"
                    color="orange darken-3"
                    label="الفواتير النهائية"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.buy_fatworas"
                    color="orange darken-3"
                    label="فواتير الشراء"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.buy_fatwora_reback"
                    color="orange darken-3"
                    label="مرتجع الشراء"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.client_sadad"
                    color="orange darken-3"
                    label="سداد العملاء"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.importer_sadad"
                    color="orange darken-3"
                    label="سداد الموردين"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.client_khasm"
                    color="orange darken-3"
                    label="خصم العملاء"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.khazina_deposit"
                    color="orange darken-3"
                    label="ايداع الخزينة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.khazina_withdrew"
                    color="orange darken-3"
                    label="سحب الخزينة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.khazina_transfer"
                    color="orange darken-3"
                    label="تحويل خزينة لاخري"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.masrofat"
                    color="orange darken-3"
                    label="مصروفات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.ohda"
                    color="orange darken-3"
                    label="عهدة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.bank_deposit"
                    color="orange darken-3"
                    label="ايداع بنك"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.bank_withdrew"
                    color="orange darken-3"
                    label="سحب بنك"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.bank_transfer"
                    color="orange darken-3"
                    label="تحويل بنك لاخر"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.cheques"
                    color="orange darken-3"
                    label="الشيكات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.employers"
                    color="orange darken-3"
                    label="الموظفين"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.omolas"
                    color="orange darken-3"
                    label="عمولات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.salary"
                    color="orange darken-3"
                    label="المرتبات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.salary_input"
                    color="orange darken-3"
                    label="المرتبات والحوافز"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.vacancy"
                    color="orange darken-3"
                    label="الاجازات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.attends"
                    color="orange darken-3"
                    label="الحضور والغياب"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.client_detail_account"
                    color="orange darken-3"
                    label="حساب عميل مفصل"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.client_account"
                    color="orange darken-3"
                    label="حساب عميل"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.importer_account"
                    color="orange darken-3"
                    label="حساب مورد"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.mandob_sales_report"
                    color="orange darken-3"
                    label="تقرير مبيعات مندوب"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.mandob_client_type_report"
                    color="orange darken-3"
                    label="تقرير مبيعات مندوب بنوع العميل"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.mandob_item_report"
                    color="orange darken-3"
                    label="تقرير مبيعات مندوب بالصنف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.mandob_client_sadad_report"
                    color="orange darken-3"
                    label="تقرير سداد العملاء بالمندوب"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.mandob_client_madionia_report"
                    color="orange darken-3"
                    label="تقرير مديونية العملاء بالمندوب"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.item_sales_report"
                    color="orange darken-3"
                    label="تقرير مبيعات صنف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.item_client_type_report"
                    color="orange darken-3"
                    label="تقرير مبيعات صنف بنوع العميل"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.store_item_transfer_report"
                    color="orange darken-3"
                    label="الاصناف المحولة للمخازن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.store_one_item_transfer_report"
                    color="orange darken-3"
                    label="صنف محول للمخازن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.store_movement_report"
                    color="orange darken-3"
                    label="حركة مخزن من الي"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.store_movement_all_report"
                    color="orange darken-3"
                    label="حركة جميع المخازن من الي"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.store_gard"
                    color="orange darken-3"
                    label="جرد مخزن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.khazina_client_sadad_report"
                    color="orange darken-3"
                    label="سداد العملاء من الي"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.khazina_input_detail_report"
                    color="orange darken-3"
                    label="تقرير شامل للخزينة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.masrof_all_report"
                    color="orange darken-3"
                    label="تقرير المصروفات من الي"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.masrof_with_type_report"
                    color="orange darken-3"
                    label="تقرير المصروفات بنوع المصروف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.khazina_input_report"
                    color="orange darken-3"
                    label="ايرادات الخزينة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.barnch_sales_report"
                    color="orange darken-3"
                    label="تقرير شامل فرع"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.company_sales_report"
                    color="orange darken-3"
                    label="تقرير شامل شركة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.branch_madionia_report"
                    color="orange darken-3"
                    label="تقرير مديونيات فرع"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.company_madionia_report"
                    color="orange darken-3"
                    label="تقرير مديونيات شركة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.user_behavior_report"
                    color="orange darken-3"
                    label="تتبع حركة السيستم"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.employer_salary_report"
                    color="orange darken-3"
                    label="مرتبات الموظفين"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.employer_omola_report"
                    color="orange darken-3"
                    label="عمولات المندوبين"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.khazina_importer_sadad_report"
                    color="orange darken-3"
                    label="سداد موردين من الي"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.item_buy_report"
                    color="orange darken-3"
                    label="مشتريات عام بالصنف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.reback_sell_all"
                    color="orange darken-3"
                    label="مرتجع مبيعات شامل"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.reback_buy_all"
                    color="orange darken-3"
                    label="مرتجع شراء عام"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.reback_item_buy_report"
                    color="orange darken-3"
                    label="مرتجع الشراء بالصنف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.reback_client_report"
                    color="orange darken-3"
                    label="مرتجع عميل"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.reback_mandob_report"
                    color="orange darken-3"
                    label="مرتجعات بالمندوب"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.reback_item_report"
                    color="orange darken-3"
                    label="مرتجع مبيعات بالصنف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.reback_importer_report"
                    color="orange darken-3"
                    label="مرتجعات بالمورد"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.fatworas_print"
                    color="orange darken-3"
                    label="طباعة الفاتورة والإذن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.offers"
                    color="orange darken-3"
                    label="  التحكم للعروض "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.client_users"
                    color="orange darken-3"
                    label="  مستخدمين العملاء"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.supervisor_orders"
                    color="orange darken-3"
                    label="  صفحة المشرف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.buy_confirmation"
                    color="orange darken-3"
                    label=" تأكيد المشتريات "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.badalat"
                    color="orange darken-3"
                    label="  بدلات الموظفين"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.hafez"
                    color="orange darken-3"
                    label=" حوافز الموظفين "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.solfa"
                    color="orange darken-3"
                    label=" سلف الموظفين "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.khasm"
                    color="orange darken-3"
                    label=" خصم الموظفين "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.mandob_target"
                    color="orange darken-3"
                    label=" تارجت المندوبين "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.AddNewClient"
                    color="orange darken-3"
                    label=" تأكيد اضافة عميل "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.mandobVisits"
                    color="orange darken-3"
                    label=" زيارات مندوب "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.Tasks"
                    color="orange darken-3"
                    label=" مهام المندوبين "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.Tahsilat"
                    color="orange darken-3"
                    label=" تحصيلات المندوبين "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.Track"
                    color="orange darken-3"
                    label=" تتبع المندوبين "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.sanf_start_q"
                    color="orange darken-3"
                    label="اضافة بداية صنف "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.global_reback"
                    color="orange darken-3"
                    label=" المرتجع العام  "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.supervisor_page"
                    color="orange darken-3"
                    label=" صفحة المشرف  "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.delete_all"
                    color="orange darken-3"
                    label="حذف وتعديل شئ مهم "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.all_profit"
                    color="orange darken-3"
                    label="الحسابات والارباح"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="add_permissions.item_profit"
                    color="orange darken-3"
                    label="الحسابات والارباح للاصناف"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-card-text>

            <div style="flex: 1 1 auto;"></div>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialog_edit_per"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          scrollable
          left
        >
          <v-card tile>
            <v-toolbar card dark color="orange">
              <v-btn icon dark @click="dialog_edit_per = false">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>اضافة الصلاحيات </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark flat @click="dialog_edit_per = false">حفظ</v-btn>
              </v-toolbar-items>
              <v-menu bottom right offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn dark icon v-on="on">
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <!-- <v-list-tile v-for="(item, i) in items" :key="i" @click="س">
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  </v-list-tile> -->
                </v-list>
              </v-menu>
            </v-toolbar>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.branches"
                    color="orange darken-3"
                    label="الفروع"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.regions"
                    color="orange darken-3"
                    label="المناطق"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.users"
                    color="orange darken-3"
                    label="المستخدمين"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.clients"
                    color="orange darken-3"
                    label="العملاء"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.importers"
                    color="orange darken-3"
                    label="الموردين"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.stores"
                    color="orange darken-3"
                    label="المخازن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.groups"
                    color="orange darken-3"
                    label="المجموعات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.items"
                    color="orange darken-3"
                    label="الاصناف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.khazinas"
                    color="orange darken-3"
                    label="الخزينة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.banks"
                    color="orange darken-3"
                    label="البنوك"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.masrofat_types"
                    color="orange darken-3"
                    label="انواع المصروفات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.cars"
                    color="orange darken-3"
                    label="السيارات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.store_employer_link"
                    color="orange darken-3"
                    label="ربط موظف بمخزن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.store_item_start"
                    color="orange darken-3"
                    label="بداية الاصناف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.store_transfer"
                    color="orange darken-3"
                    label="تحويلات المخازن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.transfer_fatworas"
                    color="orange darken-3"
                    label="فواتير تحويلات المخازن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.taslim_fatwora"
                    color="orange darken-3"
                    label="قبول المندوب اذن الصرف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.reback_fatworas"
                    color="orange darken-3"
                    label="فواتير المرتجعات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.sarf_card"
                    color="orange darken-3"
                    label="كارت صنف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.orders"
                    color="orange darken-3"
                    label="اوامر التوريد"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.tanfiz_fatworas"
                    color="orange darken-3"
                    label="قيد التنفيذ"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.sarf_from_stores"
                    color="orange darken-3"
                    label="الصرف من المخزن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.solmt_fatworas"
                    color="orange darken-3"
                    label="قبول العميل الفاتورة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.sell_reback"
                    color="orange darken-3"
                    label="مرتجعات العملاء"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.final_fatworas"
                    color="orange darken-3"
                    label="الفواتير النهائية"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.buy_fatworas"
                    color="orange darken-3"
                    label="فواتير الشراء"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.buy_fatwora_reback"
                    color="orange darken-3"
                    label="مرتجع الشراء"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.client_sadad"
                    color="orange darken-3"
                    label="سداد العملاء"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.importer_sadad"
                    color="orange darken-3"
                    label="سداد الموردين"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.client_khasm"
                    color="orange darken-3"
                    label="خصم العملاء"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.khazina_deposit"
                    color="orange darken-3"
                    label="ايداع الخزينة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.khazina_withdrew"
                    color="orange darken-3"
                    label="سحب الخزينة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.khazina_transfer"
                    color="orange darken-3"
                    label="تحويل خزينة لاخري"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.masrofat"
                    color="orange darken-3"
                    label="مصروفات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.ohda"
                    color="orange darken-3"
                    label="عهدة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.bank_deposit"
                    color="orange darken-3"
                    label="ايداع بنك"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.bank_withdrew"
                    color="orange darken-3"
                    label="سحب بنك"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.bank_transfer"
                    color="orange darken-3"
                    label="تحويل بنك لاخر"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.cheques"
                    color="orange darken-3"
                    label="الشيكات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.employers"
                    color="orange darken-3"
                    label="الموظفين"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.omolas"
                    color="orange darken-3"
                    label="عمولات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.salary"
                    color="orange darken-3"
                    label="المرتبات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.salary_input"
                    color="orange darken-3"
                    label="المرتبات والحوافز"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.vacancy"
                    color="orange darken-3"
                    label="الاجازات"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.attends"
                    color="orange darken-3"
                    label="الحضور والغياب"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.client_detail_account"
                    color="orange darken-3"
                    label="حساب عميل مفصل"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.client_account"
                    color="orange darken-3"
                    label="حساب عميل"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.importer_account"
                    color="orange darken-3"
                    label="حساب مورد"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.mandob_sales_report"
                    color="orange darken-3"
                    label="تقرير مبيعات مندوب"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.mandob_client_type_report"
                    color="orange darken-3"
                    label="تقرير مبيعات مندوب بنوع العميل"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.mandob_item_report"
                    color="orange darken-3"
                    label="تقرير مبيعات مندوب بالصنف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.mandob_client_sadad_report"
                    color="orange darken-3"
                    label="تقرير سداد العملاء بالمندوب"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.mandob_client_madionia_report"
                    color="orange darken-3"
                    label="تقرير مديونية العملاء بالمندوب"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.item_sales_report"
                    color="orange darken-3"
                    label="تقرير مبيعات صنف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.item_client_type_report"
                    color="orange darken-3"
                    label="تقرير مبيعات صنف بنوع العميل"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.store_item_transfer_report"
                    color="orange darken-3"
                    label="الاصناف المحولة للمخازن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.store_one_item_transfer_report"
                    color="orange darken-3"
                    label="صنف محول للمخازن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.store_movement_report"
                    color="orange darken-3"
                    label="حركة مخزن من الي"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.store_movement_all_report"
                    color="orange darken-3"
                    label="حركة جميع المخازن من الي"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.store_gard"
                    color="orange darken-3"
                    label="جرد مخزن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.khazina_client_sadad_report"
                    color="orange darken-3"
                    label="سداد العملاء من الي"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.khazina_input_detail_report"
                    color="orange darken-3"
                    label="تقرير شامل للخزينة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.masrof_all_report"
                    color="orange darken-3"
                    label="تقرير المصروفات من الي"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.masrof_with_type_report"
                    color="orange darken-3"
                    label="تقرير المصروفات بنوع المصروف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.khazina_input_report"
                    color="orange darken-3"
                    label="ايرادات الخزينة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.barnch_sales_report"
                    color="orange darken-3"
                    label="تقرير شامل فرع"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.company_sales_report"
                    color="orange darken-3"
                    label="تقرير شامل شركة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.branch_madionia_report"
                    color="orange darken-3"
                    label="تقرير مديونيات فرع"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.company_madionia_report"
                    color="orange darken-3"
                    label="تقرير مديونيات شركة"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.user_behavior_report"
                    color="orange darken-3"
                    label="تتبع حركة السيستم"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.employer_salary_report"
                    color="orange darken-3"
                    label="مرتبات الموظفين"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.employer_omola_report"
                    color="orange darken-3"
                    label="عمولات المندوبين"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.khazina_importer_sadad_report"
                    color="orange darken-3"
                    label="سداد موردين من الي"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.item_buy_report"
                    color="orange darken-3"
                    label="مشتريات عام بالصنف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.reback_sell_all"
                    color="orange darken-3"
                    label="مرتجع مبيعات شامل"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.reback_buy_all"
                    color="orange darken-3"
                    label="مرتجع شراء عام"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.reback_item_buy_report"
                    color="orange darken-3"
                    label="مرتجع الشراء بالصنف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.reback_client_report"
                    color="orange darken-3"
                    label="مرتجع عميل"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.reback_mandob_report"
                    color="orange darken-3"
                    label="مرتجعات بالمندوب"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.reback_item_report"
                    color="orange darken-3"
                    label="مرتجع مبيعات بالصنف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.reback_importer_report"
                    color="orange darken-3"
                    label="مرتجعات بالمورد"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.fatworas_print"
                    color="orange darken-3"
                    label="طبعاة الفاتورة والإذن"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.offers"
                    color="orange darken-3"
                    label="  التحكم للعروض "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.client_users"
                    color="orange darken-3"
                    label="  مستخدمين العملاء"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.supervisor_orders"
                    color="orange darken-3"
                    label="  صفحة المشرف"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.buy_confirmation"
                    color="orange darken-3"
                    label=" تأكيد المشتريات "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.badalat"
                    color="orange darken-3"
                    label="  بدلات الموظفين"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.hafez"
                    color="orange darken-3"
                    label=" حوافز الموظفين "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.solfa"
                    color="orange darken-3"
                    label=" سلف الموظفين "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.khasm"
                    color="orange darken-3"
                    label=" خصم الموظفين "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.mandob_target"
                    color="orange darken-3"
                    label=" تارجت المندوبين "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.AddNewClient"
                    color="orange darken-3"
                    label=" تأكيد اضافة عميل "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.mandobVisits"
                    color="orange darken-3"
                    label=" زيارات مندوب "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.Tasks"
                    color="orange darken-3"
                    label=" مهام المندوبين "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.Tahsilat"
                    color="orange darken-3"
                    label=" تحصيلات المندوبين "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.Track"
                    color="orange darken-3"
                    label=" تتبع المندوبين "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.sanf_start_q"
                    color="orange darken-3"
                    label="اضافة بداية صنف "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.global_reback"
                    color="orange darken-3"
                    label=" المرتجع العام  "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.supervisor_page"
                    color="orange darken-3"
                    label=" صفحة المشرف  "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.delete_all"
                    color="orange darken-3"
                    label="حذف وتعديل شئ مهم "
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.all_profit"
                    color="orange darken-3"
                    label="الحسابات والارباح"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 sm4 md2>
                  <v-switch
                    v-model="edit_permissions.item_profit"
                    color="orange darken-3"
                    label="الحسابات والارباح للاصناف"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-card-text>

            <div style="flex: 1 1 auto;"></div>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="users"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
        item-key="name"
      >
        <tr slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td class="text-xs-right">
            {{
              props.item.employer && props.item.employer.job
                ? props.item.employer.job.name
                : ""
            }}
          </td>
          <td class="text-xs-right">{{ props.item.username }}</td>
          <td class="justify-center layout px-0">
            <v-icon
              v-if="permissions.delete_all == 1 || user.type == 1"
              small
              class="ml-4"
              @click="editItem(props.item)"
            >
              edit
            </v-icon>
            <v-icon
              v-if="permissions.delete_all == 1 || user.type == 1"
              small
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
            <v-btn color="success" small @click="reset_password(props.item)">
              تغيير الباسورد
            </v-btn>
          </td>
        </tr>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>

      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  cities,
  users,
  add_user,
  update_user,
  delete_user,
  reset_user_password
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: "أسم المستخدم",
        align: "right",
        value: "name"
      },
      { text: "الوظيفة", value: "employer.job_name", align: "right" },
      { text: "اسم الدخول", value: "username", align: "right" },
      { text: "التحكم", value: "control", sortable: false, align: "center" }
    ],
    select_employer: { id: "", name: "أختر الموظف" },
    select_branch: { id: "", name: "أختر الفرع" },
    select_mohafza: { id: "", name: "أختر المحافظة" },
    select_city: { id: "", name: "أختر المدينة" },
    select_employer_edit: { id: "", name: "أختر الموظف" },
    select_branch_edit: { id: "", name: "أختر الفرع" },
    select_mohafza_edit: { id: "", name: "أختر المحافظة" },
    select_city_edit: { id: "", name: "أختر المدينة" },
    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    jobs: [],
    editedItem: {
      id: "",
      code: "",
      name: "",
      username: "",
      email: "",
      branch_id: "",
      mohafza_id: "",
      city_id: "",
      employer_id: ""
    },
    newItem: {
      id: "",
      code: "",
      name: "",
      username: "",
      email: "",
      password: "",
      branch_id: "",
      mohafza_id: "",
      city_id: "",
      employer_id: ""
    },
    new_code: "",
    mohafzas: [],
    cities: [],
    branches: [],
    employers: [],
    users: [],
    dialog_add_per: false,
    dialog_edit_per: false,

    add_permissions: {
      id: "",
      branches: 1,
      regions: 1,
      users: 1,
      clients: 1,
      importers: 1,
      stores: 1,
      groups: 1,
      items: 1,
      khazinas: 1,
      banks: 1,
      masrofat_types: 1,
      cars: 1,
      store_employer_link: 1,
      store_item_start: 1,
      store_transfer: 1,
      transfer_fatworas: 1,
      taslim_fatwora: 1,
      reback_fatworas: 1,
      sarf_card: 1,
      orders: 1,
      tanfiz_fatworas: 1,
      sarf_from_stores: 1,
      solmt_fatworas: 1,
      sell_reback: 1,
      final_fatworas: 1,
      buy_fatworas: 1,
      buy_fatwora_reback: 1,
      client_sadad: 1,
      importer_sadad: 1,
      client_khasm: 1,
      khazina_deposit: 1,
      khazina_withdrew: 1,
      khazina_transfer: 1,
      masrofat: 1,
      ohda: 1,
      bank_deposit: 1,
      bank_withdrew: 1,
      bank_transfer: 1,
      cheques: 1,
      employers: 1,
      omolas: 1,
      salary: 1,
      salary_input: 1,
      vacancy: 1,
      attends: 1,
      client_detail_account: 1,
      client_account: 1,
      importer_account: 1,
      mandob_sales_report: 1,
      mandob_client_type_report: 1,
      mandob_item_report: 1,
      mandob_client_sadad_report: 1,
      mandob_client_madionia_report: 1,
      item_sales_report: 1,
      item_client_type_report: 1,
      store_item_transfer_report: 1,
      store_one_item_transfer_report: 1,
      store_movement_report: 1,
      store_movement_all_report: 1,
      store_gard: 1,
      khazina_client_sadad_report: 1,
      khazina_input_detail_report: 1,
      masrof_all_report: 1,
      masrof_with_type_report: 1,
      khazina_input_report: 1,
      barnch_sales_report: 1,
      company_sales_report: 1,
      branch_madionia_report: 1,
      company_madionia_report: 1,
      user_behavior_report: 1,
      employer_salary_report: 1,
      employer_omola_report: 1,
      khazina_importer_sadad_report: 1,
      item_buy_report: 1,
      reback_sell_all: 1,
      reback_buy_all: 1,
      reback_item_buy_report: 1,
      reback_client_report: 1,
      reback_mandob_report: 1,
      reback_item_report: 1,
      reback_importer_report: 1,
      fatworas_print: 1,
      offers: 1,
      client_users: 1,
      supervisor_orders: 1,
      buy_confirmation: 1,
      badalat: 1,
      hafez: 1,
      solfa: 1,
      khasm: 1,
      mandob_target: 1,
      AddNewClient: 1,
      mandobVisits: 1,
      Tasks: 1,
      Tahsilat: 1,
      Track: 1,
      sanf_start_q: 1,
      global_reback: 1,
      supervisor_page: 1,
      delete_all: 1,
      all_profit: 1,
      item_profit: 1,
      user_id: 1
    },
    edit_permissions: {}
  }),

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    change_username() {
      this.newItem.username = this.select_employer.name;
    },
    initialize() {
      // mohafzas().then(response => {
      //   this.mohafzas = response.data;
      // });

      // branches().then(response => {
      //   this.branches = response.data;
      // });

      // employers().then(response => {
      //   this.employers = response.data;
      // });

      users().then(response => {
        this.users = response.data.users;
        this.mohafzas = response.data.mohafzas;
        this.branches = response.data.branches;
        this.employers = response.data.employers;
        this.pagination.totalItems = response.data.users.length;
        this.loading = false;
        this.branches.push({ id: 0, name: "كل الفروع" });
      });
    },

    getCities(id) {
      cities(id).then(response => {
        this.cities = response.data;
      });
    },

    editItem(item) {
      //   this.editedItem = Object.assign({}, item)
      this.initialize();
      this.getCities(item.mohafza.id);
      this.editedIndex = this.users.indexOf(item);
      this.editedItem.id = item.id;
      this.editedItem.code = item.code;
      this.editedItem.name = item.name;
      this.editedItem.username = item.username;
      this.editedItem.email = item.email;
      (this.select_employer_edit = item.employer),
        (this.select_branch_edit = item.branch),
        (this.select_mohafza_edit = item.mohafza),
        (this.select_city_edit = item.city),
        (this.edit_permissions = item.permission);
      this.edit_dialog = true;
    },

    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.users.indexOf(item);
          this.loading = true;
          var frmData = new FormData();
          delete_user(frmData, item.id).then(response => {
            this.loading = false;
            this.users.splice(index, 1);
            this.close();
          });
        }
      });
    },

    reset_password(item) {
      this.$swal({
        title: "هل تريد اعادة كلمة السر الافتراضية لهذا المستخدم",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          this.loading = true;
          reset_user_password(item.id).then(response => {
            this.loading = false;
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          this.newItem.code = this.code;
          this.newItem.branch_id = this.select_branch.id;
          this.newItem.mohafza_id = this.select_mohafza.id;
          this.newItem.city_id = this.select_city.id;
          this.newItem.employer_id = this.select_employer.id;
          this.newItem.name = this.select_employer.name;
          this.newItem.password = "123456";

          var frmData = new FormData();
          frmData.append("user", JSON.stringify(this.newItem));
          frmData.append("permissions", JSON.stringify(this.add_permissions));

          add_user(frmData)
            .then(response => {
              if (response.data == "false" || response.data == false) {
                alert("تم انشاء اسم مستخدم لهذا الموظف من قبل ");
                this.loading = false;
                return false;
              }
              Object.assign(this.$data.newItem, this.$options.data().newItem);
              Object.assign(
                this.$data.add_permissions,
                this.$options.data().add_permissions
              );
              // Object.assign(this.$data.select_employer, this.$options.data().select_employer);
              // Object.assign(this.$data.select_branch, this.$options.data().select_branch);
              // Object.assign(this.$data.select_mohafza, this.$options.data().select_mohafza);
              // Object.assign(this.$data.select_city, this.$options.data().select_city);
              this.users.push(response.data);
              this.loading = false;
              this.close();
              setTimeout(() => {
                this.$refs.form.reset();
              }, 1000);
            })
            .catch(error => {
              this.loading = false;
              this.close();
            });
        }
      });
      //   if (this.editedIndex > -1) {
      //     Object.assign(this.jobs[this.editedIndex], this.editedItem)
      //   } else {
      //     this.jobs.push(this.editedItem)
      //   }

      // this.close()
    },

    update(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          this.editedItem.branch_id = this.select_branch_edit.id;
          this.editedItem.mohafza_id = this.select_mohafza_edit.id;
          this.editedItem.city_id = this.select_city_edit.id;
          this.editedItem.employer_id = this.select_employer_edit.id;

          let item_id = this.editedItem.id;
          var frmData = new FormData();
          frmData.append("user", JSON.stringify(this.editedItem));
          frmData.append("permissions", JSON.stringify(this.edit_permissions));

          update_user(frmData, item_id).then(response => {
            Vue.set(
              this.users,
              this.users.findIndex(f => f.id === item_id),
              response.data
            );
            this.loading = false;
            this.close();
          });
        }
      });
    }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },

    mycode() {
      if (this.users.length > 0) {
        return (this.code =
          parseInt(this.users[this.users.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    }
  }
};
</script>

<style>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.v-messages__message {
  text-align: right;
}
.v-label.theme--light {
  text-align: right;
}
.backend {
  background-color: yellow !important;
}
.v-input__slot {
  direction: ltr !important;
}
.v-input__slot .v-label {
  font-weight: bold;
}
</style>
